export const TOSS = 'COINS/TOSS';
export const FLIP = 'COINS/FLIP';
export const LANDED = 'COINS/LANDED';
export const SEEN = 'COINS/SEEN';
